import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "adobe-audience-manager-event-reference"
    }}>{`Adobe Audience Manager event reference`}</h1>
    <h2 {...{
      "id": "events-handled"
    }}>{`Events handled`}</h2>
    <p>{`The following events are handled by the Audience Manager extension:`}</p>
    <h3 {...{
      "id": "audience-manager-content-request"
    }}>{`Audience Manager content request`}</h3>
    <p>{`This event updates the profile for Audience Manager and is generated when the `}<inlineCode parentName="p">{`audienceSignalWithData`}</inlineCode>{` API is called to send content to Audience Manager.`}</p>
    <h4 {...{
      "id": "event-details"
    }}>{`Event details`}</h4>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}><strong parentName="th">{`Event Type`}</strong></th>
          <th parentName="tr" {...{
            "align": "left"
          }}><strong parentName="th">{`Event Source`}</strong></th>
          <th parentName="tr" {...{
            "align": "left"
          }}><strong parentName="th">{`Paired`}</strong></th>
          <th parentName="tr" {...{
            "align": "left"
          }}><strong parentName="th">{`Paired Event`}</strong></th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`com.adobe.eventType.audienceManager`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`com.adobe.eventSource.requestContent`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Yes`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`​`}<a parentName="td" {...{
              "href": "#audience-manager-content-response"
            }}>{`Audience Manager Content Response`}</a>{`​`}</td>
        </tr>
      </tbody>
    </table>
    <h4 {...{
      "id": "data-payload-definition"
    }}>{`Data payload definition`}</h4>
    <p>{`The following lists the key-value pairs in this event:`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}><strong parentName="th">{`Key or Key Type`}</strong></th>
          <th parentName="tr" {...{
            "align": "left"
          }}><strong parentName="th">{`Value Type`}</strong></th>
          <th parentName="tr" {...{
            "align": "left"
          }}><strong parentName="th">{`Optional`}</strong></th>
          <th parentName="tr" {...{
            "align": "left"
          }}><strong parentName="th">{`Description`}</strong></th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`aamtraits`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`String Map`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`No`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`The data payload contains the traits (key-value pairs) that were sent by the customer.`}</td>
        </tr>
      </tbody>
    </table>
    <h3 {...{
      "id": "audience-manager-identity-request"
    }}>{`Audience Manager identity request`}</h3>
    <p>{`This event is a request to retrieve the visitor profile from Audience Manager and is generated when the parent application requests an audience visitor profile by using `}<inlineCode parentName="p">{`audienceGetVisitorProfile`}</inlineCode>{`.`}</p>
    <h4 {...{
      "id": "event-details-1"
    }}>{`Event details`}</h4>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}><strong parentName="th">{`Event Type`}</strong></th>
          <th parentName="tr" {...{
            "align": "left"
          }}><strong parentName="th">{`Event Source`}</strong></th>
          <th parentName="tr" {...{
            "align": "left"
          }}><strong parentName="th">{`Paired`}</strong></th>
          <th parentName="tr" {...{
            "align": "left"
          }}><strong parentName="th">{`Paired Event`}</strong></th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`com.adobe.eventType.audienceManager`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`com.adobe.eventSource.requestIdentity`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Yes`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`​`}<a parentName="td" {...{
              "href": "#audience-manager-identity-response"
            }}>{`Audience Manager identity response`}</a>{`​`}</td>
        </tr>
      </tbody>
    </table>
    <h4 {...{
      "id": "data-payload-definition-1"
    }}>{`Data payload definition`}</h4>
    <p>{`There are no key-value pair for this event.`}</p>
    <h3 {...{
      "id": "audience-manager-reset-request"
    }}>{`Audience Manager reset request`}</h3>
    <p>{`This event clears the Audience Manager profile on the device and is generated when the `}<inlineCode parentName="p">{`audienceReset`}</inlineCode>{` API is called to clear the Audience Manager profile.`}</p>
    <h4 {...{
      "id": "event-details-2"
    }}>{`Event details`}</h4>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}><strong parentName="th">{`Event Type`}</strong></th>
          <th parentName="tr" {...{
            "align": "left"
          }}><strong parentName="th">{`Event Source`}</strong></th>
          <th parentName="tr" {...{
            "align": "left"
          }}><strong parentName="th">{`Paired`}</strong></th>
          <th parentName="tr" {...{
            "align": "left"
          }}><strong parentName="th">{`Paired Event`}</strong></th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`com.adobe.eventType.audienceManager`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`com.adobe.eventSource.requestReset`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`No`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`N/A`}</td>
        </tr>
      </tbody>
    </table>
    <h4 {...{
      "id": "data-payload-definition-2"
    }}>{`Data payload definition`}</h4>
    <p>{`There are no key-value pairs for this event.`}</p>
    <h4 {...{
      "id": "hub-shared-state"
    }}>{`Hub shared state`}</h4>
    <p>{`Audience Manager listens for the configuration shared state events.`}</p>
    <h3 {...{
      "id": "configuration-response-content"
    }}>{`Configuration response content`}</h3>
    <p>{`The Audience Manager extension listens for configuration content response events to detect whether the privacy status was changed or the audience configuration was updated.`}</p>
    <p>{`For more information about the this event, see the configuration response content section of the `}<a parentName="p" {...{
        "href": "../adobe-analytics/event-reference.md#configuration-response-content"
      }}>{`Adobe Analytics event reference`}</a>{`​.`}</p>
    <h3 {...{
      "id": "lifecycle-response-content"
    }}>{`Lifecycle response content`}</h3>
    <p>{`This event is generated when there is a lifecycle session update such as a launch event or upgrade. The Audience Manager extension listens for the event and sends a new signal to Audience Manager with the lifecycle context data.`}</p>
    <p>{`For more information about the this event, see the lifecycle response content section of the `}<a parentName="p" {...{
        "href": "../adobe-analytics/event-reference.md#lifecycle-response-content"
      }}>{`Adobe Analytics event reference`}</a>{`.`}</p>
    <h3 {...{
      "id": "analytics-response-content"
    }}>{`Analytics response content`}</h3>
    <p>{`Audience Manager listens for Adobe Analytics response events, which are sent when audience forwarding is enabled, processes the events, and extracts the destinations where the new signals will be sent.`}</p>
    <p>{`For more information about this event, see the Analytics response content section of the `}<a parentName="p" {...{
        "href": "../adobe-analytics/event-reference.md#analytics-response-content"
      }}>{`Adobe Analytics event reference`}</a>{`.`}</p>
    <h2 {...{
      "id": "events-dispatched"
    }}>{`Events dispatched`}</h2>
    <p>{`The following events are dispatched by the Audience Manager extension:`}</p>
    <h3 {...{
      "id": "audience-manager-content-response"
    }}>{`Audience Manager content response`}</h3>
    <p>{`This event delivers the Audience Manager profile to the following:`}</p>
    <ul>
      <li parentName="ul">{`The original requester.`}</li>
      <li parentName="ul">{`A module that might be listening for updates.`}</li>
    </ul>
    <p>{`The event is generated when a request is made to:`}</p>
    <ul>
      <li parentName="ul">{`Update the Audience Manager profile.`}</li>
      <li parentName="ul">{`Retrieve the current Audience Manager profile.`}</li>
    </ul>
    <h4 {...{
      "id": "event-details-3"
    }}>{`Event details`}</h4>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}><strong parentName="th">{`Event Type`}</strong></th>
          <th parentName="tr" {...{
            "align": "left"
          }}><strong parentName="th">{`Event Source`}</strong></th>
          <th parentName="tr" {...{
            "align": "left"
          }}><strong parentName="th">{`Paired`}</strong></th>
          <th parentName="tr" {...{
            "align": "left"
          }}><strong parentName="th">{`Paired Event`}</strong></th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`com.adobe.eventType.audienceManager`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`com.adobe.eventSource.responseContent`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Yes`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`​`}<a parentName="td" {...{
              "href": "#audience-manager-content-request"
            }}>{`Audience Manager Content Request`}</a>{`​`}</td>
        </tr>
      </tbody>
    </table>
    <h4 {...{
      "id": "data-payload-definition-3"
    }}>{`Data payload definition`}</h4>
    <p>{`The following lists the key-value pairs in this event:`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}><strong parentName="th">{`Key`}</strong></th>
          <th parentName="tr" {...{
            "align": "left"
          }}><strong parentName="th">{`Value Type`}</strong></th>
          <th parentName="tr" {...{
            "align": "left"
          }}><strong parentName="th">{`Optional`}</strong></th>
          <th parentName="tr" {...{
            "align": "left"
          }}><strong parentName="th">{`Description`}</strong></th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`aamprofile`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`String Map`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Yes`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`The data payload contains the customer key value pairs. The data payload is populated using the CV and CN values in the Audience Manager Stuff array.`}</td>
        </tr>
      </tbody>
    </table>
    <h3 {...{
      "id": "audience-manager-identity-response"
    }}>{`Audience Manager identity response`}</h3>
    <p>{`This event delivers the Audience Manager profile to:`}</p>
    <ul>
      <li parentName="ul">{`The original requester`}</li>
      <li parentName="ul">{`Any module that might be listening for updates`}</li>
    </ul>
    <p>{`The event is generated when a request is made to update the Audience manager profile.`}</p>
    <h4 {...{
      "id": "event-details-4"
    }}>{`Event details`}</h4>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}><strong parentName="th">{`Event Type`}</strong></th>
          <th parentName="tr" {...{
            "align": "left"
          }}><strong parentName="th">{`Event Source`}</strong></th>
          <th parentName="tr" {...{
            "align": "left"
          }}><strong parentName="th">{`Paired`}</strong></th>
          <th parentName="tr" {...{
            "align": "left"
          }}><strong parentName="th">{`Paired Event`}</strong></th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`com.adobe.eventType.audienceManager`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`com.adobe.eventSource.responseIdentity`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Yes`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`​`}<a parentName="td" {...{
              "href": "#audience-manager-identity-request"
            }}>{`Audience Manager identity request`}</a>{`​`}</td>
        </tr>
      </tbody>
    </table>
    <h4 {...{
      "id": "data-payload-definition-4"
    }}>{`Data payload definition`}</h4>
    <p>{`Here are the key-value pairs in this event:`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}><strong parentName="th">{`Key`}</strong></th>
          <th parentName="tr" {...{
            "align": "left"
          }}><strong parentName="th">{`Value Type`}</strong></th>
          <th parentName="tr" {...{
            "align": "left"
          }}><strong parentName="th">{`Optional`}</strong></th>
          <th parentName="tr" {...{
            "align": "left"
          }}><strong parentName="th">{`Description`}</strong></th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`aamprofile`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`String Map`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`No`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Audience Manager Visitor Profile`}</td>
        </tr>
      </tbody>
    </table>
    <h2 {...{
      "id": "shared-states"
    }}>{`Shared states`}</h2>
    <p><inlineCode parentName="p">{`MODULE_NAME`}</inlineCode>{`: `}<inlineCode parentName="p">{`com.adobe.module.audience`}</inlineCode></p>
    <p>{`The shared state for this module is updated in the following scenarios:`}</p>
    <ul>
      <li parentName="ul"><strong parentName="li">{`At Initialization`}</strong>{`: After the module is initialized, it updates the shared state by reading the previously set value from persistence.`}</li>
      <li parentName="ul"><strong parentName="li">{`With Audience Manager API calls`}</strong>{`: The shared stare is updated when the `}<inlineCode parentName="li">{`submitsignal`}</inlineCode>{` API is called.`}</li>
    </ul>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Key`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`uuid`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`String`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`The UUID assigned by the Audience server.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`aamprofile`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Dictionary/Map`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`The matching visitor profile segments associated with the user.`}</td>
        </tr>
      </tbody>
    </table>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      